function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
/**
 * The base font command.
 *
 * @extends module:core/command~Command
 */

var FontCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(FontCommand, _Command);

  /**
   * Creates an instance of the command.
   *
   * @param {module:core/editor/editor~Editor} editor Editor instance.
   * @param {String} attributeKey The name of a model attribute on which this command operates.
   */
  function FontCommand(editor, attributeKey) {
    var _this;

    _classCallCheck(this, FontCommand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FontCommand).call(this, editor));
    /**
     * When set, it reflects the {@link #attributeKey} value of the selection.
     *
     * @observable
     * @readonly
     * @member {String} module:font/fontcommand~FontCommand#value
     */

    /**
     * A model attribute on which this command operates.
     *
     * @readonly
     * @member {Boolean} module:font/fontcommand~FontCommand#attributeKey
     */

    _this.attributeKey = attributeKey;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FontCommand, [{
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      this.value = doc.selection.getAttribute(this.attributeKey);
      this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, this.attributeKey);
    }
    /**
     * Executes the command. Applies the `value` of the {@link #attributeKey} to the selection.
     * If no `value` is passed, it removes the attribute from the selection.
     *
     * @protected
     * @param {Object} [options] Options for the executed command.
     * @param {String} [options.value] The value to apply.
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var document = model.document;
      var selection = document.selection;
      var value = options.value;
      model.change(function (writer) {
        if (selection.isCollapsed) {
          if (value) {
            writer.setSelectionAttribute(_this2.attributeKey, value);
          } else {
            writer.removeSelectionAttribute(_this2.attributeKey);
          }
        } else {
          var ranges = model.schema.getValidRanges(selection.getRanges(), _this2.attributeKey);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var range = _step.value;

              if (value) {
                writer.setAttribute(_this2.attributeKey, value, range);
              } else {
                writer.removeAttribute(_this2.attributeKey, range);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      });
    }
  }]);

  return FontCommand;
}(Command);

export { FontCommand as default };